import { StarsRating } from "@comparaonline/ui-reviews-stars-rating";
import Typography from "@material-ui/core/Typography";
import React from "react";

import { RatingProps } from "../types";
import { Styles, withStyles } from "./styles";

type HasValidRating = (rating: RatingProps) => boolean;
const hasValidRating: HasValidRating = ({ averageValue, total }) => averageValue > 0 && total > 0;

export const BaseRating: React.FC<RatingProps & Styles> = ({ averageValue, total, classes }) =>
  hasValidRating({ averageValue, total }) ? (
    <div className={classes.container}>
      <StarsRating iconProps={{ size: "xs" }} ratingProps={{ initialRating: averageValue }} />{" "}
      <Typography
        variant="subtitle2"
        component="span"
        color="textSecondary"
        className={classes.ratingText}
      >
        {total}
      </Typography>
    </div>
  ) : null;

export const Rating = withStyles(BaseRating);
